module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner specal"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [(_vm.attribute.columnName === 'TVInfo.usageID' || _vm.attribute.columnName === 'TVInfo2.usageID') ? _c('span', [_vm._v("载体用途说明")]) : _c('span', [_vm._v(_vm._s(this.attribute.label))])]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [(_vm.attribute.columnName === 'TVInfo.usageID' || _vm.attribute.columnName === 'TVInfo2.usageID') ? _c('span', [_vm._v("载体用途说明")]) : _c('span', [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), (_vm.attribute.columnName === 'ExpressionTest' || _vm.attribute.columnName === 'InducingTest' || _vm.attribute.columnName === 'LVAmount' || _vm.attribute.columnName === 'NC_LV_Amount') ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.showMessage(_vm.attribute)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.attribute.description) ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(_vm.attribute.description)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e()]), _vm._v(" "), ((_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) && _vm.attribute.valueText.length >= 50) ? _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "0px solid #e7e7e7",
      "margin-bottom": "3rem"
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]) : ((_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) && _vm.attribute.valueText.length >= 12 && _vm.attribute.valueText.length < 50) ? _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "0px solid #e7e7e7"
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]) : ((_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) && _vm.attribute.valueText.length < 12) ? _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "1px solid #e7e7e7"
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]) : _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "1px solid #e7e7e7"
    },
    on: {
      "click": function($event) {
        return _vm.showOptionList(_vm.attribute)
      }
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.valueText),
      expression: "attribute.valueText"
    }],
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": (_vm.attribute.valueText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "valueText", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "icon icon-down",
    staticStyle: {
      "margin-top": ".2rem",
      "margin-right": ".5rem",
      "color": "gray"
    },
    attrs: {
      "disabled": "disabled"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7760fd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finder/FinderBox/FinderAttrEnumBox.vue
// module id = 1735
// module chunks = 8